import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

// A notification tapped while OWL is already open reaches the page as a message from the
// service worker (public/push-sw.js). Setting the hash hands it to whichever shell is
// mounted, since both route from hashchange. Only same-origin in-app hashes are accepted.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    const data = event.data as { type?: unknown; hash?: unknown } | null;
    if (
      data?.type === 'owl:navigate' &&
      typeof data.hash === 'string' &&
      data.hash.startsWith('#/')
    ) {
      window.location.hash = data.hash;
    }
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element missing');
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
